import { ReactNode } from 'react';
import { ApiDate, WapAppAuth, WapAppStatus, WapAppUserLimit } from '../../../../../../api/interfaces';

export interface WapAppsResponse {
  apps: WapAppResponseItem[];
  limits: WapAppUserLimit;
}

export interface WapAppResponseItem {
  appId: string;
  createDate: ApiDate;
  settings: WapAppResponseSettingsItem;
}

export interface WapAppResponseSettingsItem {
  appUrl: string;
  authorizationMethod: {
    type: WapAppAuth;
    key?: string;
  };
  process: WapProcess;
  debugEnabled: boolean;
  externalAddress: string;
  smsTemplate: string;
  status: WapAppStatus;
}

export interface Params {
  [key: string]: string;
}

export interface WapProcess {
  id: string;
  params: Params;
}

export interface WapAppTableRowActions {
  edit: (wapAppEditData: WapAppEditData) => void;
}

export interface WapAppTableData {
  id: string;
  createDate: ApiDate;
  appUrl: string;
  status: string;
  debugEnabled: boolean;
  actions: ReactNode;
}

export interface WapAppEditData {
  appId: string;
  appUrl: string;
  debugEnabled: boolean;
  authorizationMethod: {
    type: WapAppAuth;
    key?: string;
  };
  process: WapProcess;
  status: string;
  externalAddress: string;
  smsTemplate: string;
}

export enum BUSINESS_ERRORS {
  'APP_INVALID_URL' = 'APP_INVALID_URL',
  'APP_NOT_FOUND' = 'APP_NOT_FOUND',
  'INVALID_SMS_TEMPLATE' = 'INVALID_SMS_TEMPLATE'
}

export type WapAppFormData = WapAppEditData;
